import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_activewear: FaireCategoryEntity = {
  token: "cat_women-activewear",
  type: "category",
  name: "Activewear",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/activewear",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
